import { typeFn } from '#utils/typeFn';

const fn = typeFn<string>()();

export default fn;
